import React from "react";
import Frame from "../../../../../Frame";
import { BaggageSegment } from "../../../../../IncludedBaggage/components/BaggageSegment";
import { UIFlightSegment, UIIncludedProductBySegmentCompressed } from "@flights/types";

const IncludedBaggageList = ({
  flightSegments,
  includedProducts,
  hideIncludedSection
}: {
  flightSegments: UIFlightSegment[];
  includedProducts: UIIncludedProductBySegmentCompressed;
  hideIncludedSection?: boolean;
}) => {
  const { segments: baggageSegments, areAllSegmentsIdentical } = includedProducts;

  return (
    <>
      {baggageSegments.map((baggageSegment, index) => {
        const isLastSegment = index === baggageSegments.length - 1;
        if (baggageSegment.length > 0) {
          return (
            <Frame mb={isLastSegment ? 0 : 1} key={index} attributes={{ "data-testid": `included_baggage_${index}` }}>
              <BaggageSegment
                flightSegment={flightSegments[index]}
                baggageSegment={baggageSegment}
                showHeader={!areAllSegmentsIdentical}
                hideIncludedSection={hideIncludedSection}
              />
            </Frame>
          );
        } else {
          return null;
        }
      })}
    </>
  );
};

export default IncludedBaggageList;
